import { render } from "./Presentation.vue?vue&type=template&id=5847a754&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=js"
export * from "./Presentation.vue?vue&type=script&lang=js"

import "./Presentation.vue?vue&type=style&index=0&id=5847a754&lang=css"
import "./Presentation.vue?vue&type=style&index=1&id=5847a754&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5847a754"]])

export default __exports__